import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { v4 as uuidv4 } from 'uuid';


import { categoriesIncomes, categoriesExpenses, schema } from '../../data';
import wait from '../Utils/wait';

import './style.scss';
import './loader.css';

const AddForm = (props) => {
  const { setExpenses, setIncomes, calculateBalance } = props;

  const exportToStorage = (item) => {
    const currentStorage = window.localStorage.getItem('items');
    console.log(currentStorage);
    if (currentStorage) {
      const newStorage = [...JSON.parse(currentStorage), item];
      window.localStorage.setItem('items', JSON.stringify(newStorage));
    }
    else {
      window.localStorage.setItem('items', JSON.stringify([item]));
    }
  }
  
  const onChange = (e) => {
    const { property } = e.currentTarget.dataset;
    values[property] = e.currentTarget.value;
  };

  const onSubmit = async () => {
    await wait(500);
    values.id = uuidv4();
    if (values.type === 'expense') {
      setExpenses((prevState) => {
        console.log(prevState);
        if(prevState !== []) {

          return [...prevState, values];
        }
        return values;
      });
    } else {
      setIncomes((prevState) => [...prevState, values]);
    }
    values.category = document.querySelector('select#category').value;
    const form = document.querySelector('#adder > form');
    
    exportToStorage(values);
    
    resetForm({
      values: {
        type: 'expense',
        title: '',
        amount: 0,
        category: categoriesExpenses,
        id: null,
      }
    });
    form.reset();
    setCurrentCategories(categoriesExpenses);
    calculateBalance();
  };

  const { values, errors, handleReset, resetForm, handleSubmit, handleChange, touched, isSubmitting } =
    useFormik({
      initialValues: {
        type: 'expense',
        title: '',
        amount: 0,
        category: categoriesExpenses[0],
        id: null,
      },
      onSubmit,
      onChange,
      validationSchema: schema,
    });

  const [currentCategories, setCurrentCategories] = useState(categoriesExpenses);

    // useEffect(() => {
    //   setCurrentCategories(categoriesExpenses);
    // }, [values.amount])

  const switchCategories = (e) => {
    const currentCats = e.currentTarget.value.split(',');
    values.type = e.currentTarget.id;
    console.log('Values:',values);
    setCurrentCategories(currentCats);

    // update category - doesn't update when switching type!
    const categoryInput = document.querySelector('select[name="category"]');
    values.category = categoryInput.value;
  };

  const handleBlur = (e) => {

    console.log('Errors:', errors);
    console.log('Values:', values);
  };

  return (
    // eslint-disable-next-line react/destructuring-assignment, react/prop-types
    <div className="box modal" id={props.id}>
      <h2>Add Expense / Income</h2>
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="type flex-row">
          <p>Type of transaction:</p>
          <label htmlFor="expense">
            <input
              onChange={(e) => switchCategories(e)}
              onBlur={(e) => handleBlur(e)}
              type="radio"
              name="expenseOrIncome"
              id="expense"
              defaultChecked
              value={categoriesExpenses}
  
            />
            Expense
          </label>

          <label htmlFor="income">
            <input
              onChange={(e) => switchCategories(e)}
              onBlur={(e) => handleBlur(e)}
              type="radio"
              name="expenseOrIncome"
              id="income"
              value={categoriesIncomes}
            />
            Income
          </label>
        </div>

        <div
          className={touched.type && errors.type ? 'error-info visible' : 'error-info'
          }
        >
          &nbsp;{errors.type}
        </div>



        {/* TITLE */}
        <div className="title flex-row sp-between">
          <label htmlFor="name">Title:</label>
          <input
            value={values.title}
            onChange={handleChange}
            onBlur={(e) => handleBlur(e)}
            placeholder="title of item"
            type="text"
            name="title"
            id="name"
            data-property="title"
            className={touched.title && errors.title ? 'error-border' : ''}
          />
        </div>

        <div
          className={
            touched.title && errors.title ? 'error-info visible' : 'error-info'
          }
        >
          &nbsp;{errors.title}
        </div>

        <div className="money flex-row sp-between">
          <label htmlFor="money">Amount of money:</label>
          <input
            onChange={handleChange}
            onBlur={(e) => handleBlur(e)}
            placeholder="cost / income"
            type="number"
            name="amount"
            id="amount"
            value={values.amount}
            data-property="amount"
            className={touched.amount && errors.amount ? 'error-border' : ''}
          />
        </div>

        <div
          className={
            touched.amount && errors.amount ? 'error-info visible' : 'error-info'
          }
        >
          &nbsp;{errors.amount}
        </div>

        <div className="category flex-row sp-between">
          <label htmlFor="category">Category:</label>
          <select
            onChange={(e) => handleChange(e)}
            required
            defaultValue="none"
            name="category"
            id="category"
            data-property="category"
            className={touched.category && errors.category ? 'error-border' : ''}
          >
            {currentCategories ? (
              <option disabled>Your category</option>
            ) : (
              ''
            )}
            {currentCategories ? (
              currentCategories.map((cat, index) => (
                <option key={`react-key-${index}`} value={cat}>
                  {cat}
                </option>
              ))
            ) : (
              <option>Select type first</option>
            )}
          </select>
        </div>
        <div
          className={
            touched.category && errors.category ? 'error-info visible' : 'error-info'
          }
        >
          &nbsp;{errors.category}
        </div>
        <div className="category flex-row flex-end">
          {isSubmitting ? (
            <div className="lds-default">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          ) : (
            <input
            onBlur={(e) => handleBlur(e)}
            className="button" 
            type="submit" 
            value="Add item" 
            />
          )}
        </div>
      </form>
    </div>
  );
};

export default AddForm;
